<template>
  <div class="app">
    <AppHeader fixed>
      <SidebarToggler class="d-lg-none" display="md" mobile />
      <b-link class="navbar-brand" to="#">
        <img class="navbar-brand-full" :src="`${image_base_url}/img/brand/exedy-logo-color.svg`" width="89" height="25" alt="EXEDY Logo">
        <img class="navbar-brand-minimized" :src="`${image_base_url}/img/brand/exedy-logo-color.svg`" width="30" height="30" alt="EXEDY Logo">
      </b-link>
      <SidebarToggler class="d-md-down-none" display="lg" />
      <b-navbar-nav class="ml-auto">
        <DefaultHeaderDropdownAccnt/>
      </b-navbar-nav>
      <div style="margin-right:3vw" />
      <!--<AsideToggler class="d-lg-none" mobile />-->
    </AppHeader>
    <div class="app-body">
      <AppSidebar fixed>
        <SidebarHeader/>
        <SidebarForm/>
        <SidebarNav :navItems="nav"></SidebarNav>
        <SidebarFooter/>
        <SidebarMinimizer/>
      </AppSidebar>
      <main class="main">
        <Breadcrumb :list="list"/>
        <div class="container-fluid">
          <router-view></router-view>
        </div>
      </main>
      <AppAside fixed>
        <!--aside-->
      </AppAside>
    </div>
    <TheFooter>
      <!--footer-->
      <div class="ml-auto">
        <a href="/">EXEDY</a>
        <span class="ml-1">&copy; {{(new Date()).getFullYear()}}.</span>
      </div>
      <!-- <div class="ml-auto">
        <span class="mr-1">Powered by</span>
        <a href="https://coreui.io">CoreUI for Vue</a>
      </div> -->
    </TheFooter>
  </div>
</template>

<script>
import nav from '@/_nav'
import { Header as AppHeader, SidebarToggler, Sidebar as AppSidebar, SidebarFooter, SidebarForm, SidebarHeader, SidebarMinimizer, SidebarNav, Aside as AppAside, AsideToggler, Footer as TheFooter, Breadcrumb } from '@coreui/vue'
//import DefaultAside from './DefaultAside'
import DefaultHeaderDropdownAccnt from './DefaultHeaderDropdownAccnt'

// const envi = process.env

export default {
  name: 'full',
  components: {
    AsideToggler,
    AppHeader,
    AppSidebar,
    AppAside,
    TheFooter,
    Breadcrumb,
    DefaultHeaderDropdownAccnt,
    SidebarForm,
    SidebarFooter,
    SidebarToggler,
    SidebarHeader,
    SidebarNav,
    SidebarMinimizer
  },
  data () {
    return {
      nav:nav.items,
      image_base_url:this.$helper.envi.VUE_APP_BASEURL
    }
  },
  methods:{
    checkRole(){
      this.$auth.checkSession()

      let role = this.$auth.session.get('role')
      if(role == 'officer'){
        let els1 = document.getElementsByClassName('restricted')
        for(let i=0; i<els1.length; i++){
          els1[i].style.display = 'none'
        }

        let els2 = document.getElementsByClassName('restricted-icon')
        for(let i=0; i<els2.length; i++){
          els2[i].parentElement.parentElement.style.display = 'none'
        }
      }
		},
  },
  computed: {
    name(){
      return this.$route.name
    },
    list(){
      return this.$route.matched.filter((route) => route.name || route.meta.label )
    }
  },
  mounted(){
    this.$nextTick(function(){
      this.checkRole()
    })
  }
}
</script>
